import React, { useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import { useSelector } from "react-redux";

// get user data from state
const authData = (state) => state.auth.client;
let menuItems = [
  {
    name: "Contact",
    path: "/",
    // icon: <CogIcon className="h-5 w-5  " />,
  },
  {
    name: "Support",
    path: "/",
    // icon: <CogIcon className="h-5 w-5  " />,
  },
  {
    name: "Logout",
    path: "/",
    // icon: <LogoutIcon className="h-5 w-5  " />,
  },
];

function Dropdown(props) {
  const [display, setdisplay] = useState(false);
  const user = useSelector(authData);
  let handleMenu = () => {
    setdisplay(!display);
  };

  let handleLogout = () => {
    props.logout();
  };
  return (
    <div>
      <div className="relative block text-left">
        <button
          type="button"
          onClick={handleMenu}
          className="flex flex-row items-center"
        >
          <p className=" font-medium text-gray-700 " id="menu-button">
            {user && user.name}
          </p>
          <FaAngleDown className="mx-2" />
        </button>

        {display ? (
          <>
            <div
              id="menu"
              className={`absolute left-0 mt-2  w-48 shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none`}
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              tabIndex="-1"
            >
              <div className="py-1" role="none">
                {menuItems &&
                  menuItems.map((item, index) => {
                    return (
                      <div key={index}>
                        {item.name === "Logout" ? (
                          <button
                            onClick={handleLogout}
                            className={`cursor-pointer flex flex-row items-center p-2 text-[#3B4345] hover:text-[#007E8C]`}
                          >
                            {item.icon}
                            <p className=" block text-sm ml-2">{item.name}</p>
                          </button>
                        ) : item.name === "Contact" ? (
                          <div
                            onClick={() => {}}
                            className={`cursor-pointer flex flex-row items-center border-b-2 p-2 text-[#3B4345] hover:text-[#007E8C]`}
                          >
                            {item.icon}
                            <p className="block  text-sm ml-2">{item.name}</p>
                          </div>
                        ) : item.name === "Support" ? (
                          <div
                            onClick={() => {}}
                            className={`cursor-pointer flex flex-row items-center border-b-2 p-2 text-[#3B4345] hover:text-[#007E8C]`}
                          >
                            {item.icon}
                            <p className="block  text-sm ml-2">{item.name}</p>
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}

export default Dropdown;
